import dsBridge from "dsbridge";
const dsBridgeSDK = {
  /**
   * 前端调用app的方法
   * @param {string} name app方法名
   * @param {any} data 携带参数
   * @param {function} callback 回调方法,接收app传递的数据
   */
  callNativeHandler(name, data, callback) {
    dsBridge.call(name, data, (res) => {
      let responseData = {};
      if (res) {
        responseData = JSON.parse(res);
      }
      if (typeof callback === "function") {
        // 如果是获取token等相关参数
        if (name === 'getClientCommonMessage') {
          res && localStorage.setItem('clientCommonMessage', res)
          // console.log('dsbridge', name, res)
        }
        callback(responseData);
      }
    });
  },
  /**
   * app调用前端方法
   * @param {string} name 前端方法名
   * @param {function} callback 回调方法,接收app传递的数据,并返回数据给app
   */
  registerLocalHandler(name, callback) {
    dsBridge.register(name, callback);
  },
};

export default dsBridgeSDK;
